export function useCheckUserExistsByEmail() {
  const userExistsByEmail = ref<boolean | null>(null)
  const isLoading = ref(false)
  const error = ref<string | null>(null)

  const checkUserExists = async (email: string): Promise<boolean | null> => {
    try {
      isLoading.value = true
      await kftApiRequest<Record<string, never>>('/v1/auth/accountlookup', {
        method: 'POST',
        body: { email },
      })
      // If response is empty but status is success, user exists
      userExistsByEmail.value = true
      return true
    } catch (err: any) {
      if (err?.status === 404) {
        userExistsByEmail.value = false
        return false
      }
      error.value = 'Failed to check user existence'
      return null
    } finally {
      isLoading.value = false
    }
  }

  const resetState = () => {
    userExistsByEmail.value = null
    error.value = null
  }

  return {
    userExistsByEmail,
    isLoading,
    error,
    checkUserExists,
    resetState,
  }
}
